<div
  class="flex items-center gap-1.5 text-base font-main text-navy-90 overflow-hidden"
  [ngClass]="{ 'opacity-75 hover:opacity-100': !value }"
>
  @if (!hideButton) {
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      [style.min-width.px]="size"
      [style.min-height.px]="size"
      [style.height.px]="size"
      [style.width.px]="size"
      [attr.viewBox]="viewBox"
    >
      <circle
        class="outer"
        [attr.cx]="outerCircleConfig.cx"
        [attr.cy]="outerCircleConfig.cy"
        [attr.r]="outerCircleConfig.r"
      />

      @if (value) {
        <circle
          class="fill-navy-90"
          [attr.cx]="innerCircleConfig.cx"
          [attr.cy]="innerCircleConfig.cy"
          [attr.r]="innerCircleConfig.r"
        />
      }
    </svg>
  }
  <ng-content></ng-content>
  @if (infoIconTranslationKey) {
    <app-info-icon [tooltipText]="infoIconTranslationKey | translate" [tooltipPosition]="'top'"></app-info-icon>
  }
</div>
